<template>
    <div class="view budget-tasks">
        <app-sub-navbar parent="budget"></app-sub-navbar>
        <div class="container"  v-if="loaded">
            <div class="row">
                <div class="col-12">
                    <app-budget-tasks module="budget"></app-budget-tasks>
                </div>
            </div>
        </div>
        <div class="container" v-else>
            <el-card class="box-card">
                <div class="card-body no-padding">
                    <div class="loader-container" >
                        <facebook-loader :speed="3" :animate=true :height=130 :width=400></facebook-loader>
                    </div>
                </div>
            </el-card>
        </div>
        <div class="container mt-50" v-if="loaded">
            <div class="row">
                <div class="col-12">
                    <app-historic-tasks module="budget"></app-historic-tasks>
                </div>
            </div>
        </div>
        <div class="container mt-50" v-else>
            <el-card class="box-card">
                <div class="card-body no-padding">
                    <div class="loader-container" >
                        <facebook-loader :speed="3" :animate=true :height=130 :width=400></facebook-loader>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import SubNavbar from '../../components/SubNavbar'
import BudgetTasks from '../../components/TasksComponent'
import HistoricTasks from '../../components/HistoricTasks'
import { FacebookLoader } from 'vue-content-loader'

export default {
    data () {
        return {
            loaded: true
        }
    },
    components: {
        appSubNavbar: SubNavbar,
        appBudgetTasks: BudgetTasks,
        FacebookLoader,
        appHistoricTasks: HistoricTasks
    },
    created () {
    }
}
</script>
